/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect, useRef, useState } from "react";

export const useSpeechRecognition = () => {
    const [isListening, setIsListening] = useState(false);
    const recognitionRef = useRef<any>(null);
    const [hasRecognition, setHasRecognition] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined") return;

        const SpeechRecognition =
            (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;

        if (SpeechRecognition) {
            setHasRecognition(true);
            const recognition = new SpeechRecognition();
            recognition.continuous = true;
            recognition.interimResults = true;
            recognition.lang = "en-US"; // Default language
            recognitionRef.current = recognition;
        }
    }, []);

    const startListening = useCallback(
        (onResult: (text: string, isFinal: boolean) => void, onError?: (error: string) => void) => {
            if (!recognitionRef.current) return;

            const recognition = recognitionRef.current;

            recognition.onstart = () => setIsListening(true);

            recognition.onend = () => {
                setIsListening(false);
            };

            recognition.onresult = (event: any) => {
                const currentTranscript = Array.from(event.results)
                    .map((result: any) => result[0].transcript)
                    .join("");

                onResult(currentTranscript, false);
            };

            recognition.onerror = (event: any) => {
                console.error("Speech recognition error", event.error);
                setIsListening(false);
                onError?.(event.error);
            };

            try {
                recognition.start();
            } catch (e) {
                console.error("Failed to start recognition", e);
            }
        },
        [],
    );

    const stopListening = useCallback(() => {
        if (recognitionRef.current) {
            recognitionRef.current.stop();
        }
    }, []);

    return {
        isListening,
        startListening,
        stopListening,
        hasRecognition,
    };
};
